import * as React from 'react'
import { Link } from 'react-router-dom'
import * as moment from 'moment'
import { cutString } from '../../util'
import { Menu, Button, Dropdown } from 'antd'

import './index.css'

class ArticleBox extends React.Component<any, any> {
    private reportName: any = ['查看报告正文', '查看报告全文']

    constructor(props: any) {
        super(props)
    }

    handleJumpAuthor(secId: any) {
        const {jumpToAuthor} = this.props
        jumpToAuthor(secId)
    }

    handleJumpPdf(url: any) {
        const {jumpToPdf} = this.props
        jumpToPdf(url)
    }

    handleUpdateFavorite(state: any, index: number) {
        const {handleFavoriteState} = this.props
        handleFavoriteState(state, index)
    }

    getMenu(item: any) {
        return (
            <div>
                <Menu>
                    {
                        item.attachment_url && item.attachment_url.length >= 2 && item.attachment_url.map((url: any, i: number) =>
                            <Menu.Item key={i}>
                                {/*<a onClick={() => this.goTo(url)}>查看PDF{i}</a>*/}
                                <a target="_blank" rel="noopener noreferrer" href={url}>{this.reportName[i]}</a>
                            </Menu.Item>
                        )
                    }
                </Menu>
            </div>
        )
    }

    render() {
        const {reports} = this.props
        const current = reports ? reports : []
        // console.log(current)
        return (
          <div>
              {
                  current.map((item: any, index: number) =>
                      <div className="article-item" key={item.report_id ? item.report_id : item._id}>
                          <div className="title">
                              <Link to={`/article/${item.report_id ? item.report_id : item._id}`} target="_blank">{item.article_title ? item.article_title : item._source.article_title}</Link>
                          </div>
                          <div className="subtitle">
                              {
                                  item.authors && item.authors.length > 0 && item.authors.map((author: any, index: number) =>
                                      <div className="item detail-author" key={author.sec_id} onClick={() => this.handleJumpAuthor(author.sec_id)}>
                                          <Link to={`/author/${author.sec_id}`}>
                                              {author.analyst_name}
                                          </Link>
                                      </div>
                                  )
                              }
                              {
                                  item._source.authors && item._source.authors.length > 0 &&  Array.from(new Set(item._source.authors)).map((author: any, index: number) =>
                                      <div className="item detail-author" key={index} onClick={() => this.handleJumpAuthor(index)}>
                                          <Link to={`/author/${index}`}>
                                              {author}
                                          </Link>
                                      </div>
                                  )
                              }
                              <div className="item">
                                  {item.category}
                              </div>
                              {
                                  item.organization &&
                                  <div className="item">
                                      {item.organization}
                                  </div>
                              }
                              {
                                  (item.create_time || item._source.created_at) &&
                                  <div className="item">
                                      {moment(parseInt(item.create_time ? item.create_time : item._source.created_at, 10)).format('YYYY.MM.DD')}
                                  </div>
                              }
                          </div>
                          <div className="abstract">
                              {item.article_content ? cutString(item.article_content, 300) : (item._source.article_content ? cutString(item._source.article_content, 300) : '')}
                          </div>
                          <div className="state">
                              {
                                  item.attachment_url && item.attachment_url.length >= 2 ?
                                      <div className="dropDownMenu">
                                          <Dropdown overlay={this.getMenu(item)}>
                                              <Button className="item none-button-border">
                                                  <i className="fa fa-file-pdf-o"/>
                                                  查看PDF{item.pages ? '(' + item.pages + '页)' : ''}</Button>
                                          </Dropdown>
                                      </div>
                                      :
                                      <div className="item">
                                          <div onClick={() => this.handleJumpPdf(item.attachment_url[0])}>
                                              <i className="fa fa-file-pdf-o"/>
                                              查看PDF{item.pages ? '(' + item.pages + '页)' : ''}
                                          </div>
                                      </div>
                              }
                              {
                                  item.article_url &&
                                  <div className="item">
                                      <div onClick={() => this.handleJumpPdf(item.article_url)}>
                                          <i className="fa fa-external-link"/>
                                          <span>查看原文</span>
                                      </div>
                                  </div>
                              }
                              <div className="item">
                                  {
                                      !item.enable_favorites ?
                                          <div onClick={() => this.handleUpdateFavorite('add', index)}>
                                              <i className="fa fa-bookmark-o"/>
                                              添加收藏
                                          </div>
                                          : <div onClick={() => this.handleUpdateFavorite('delete', index)}>
                                              <i className="fa fa-bookmark"/>
                                              已收藏
                                          </div>

                                  }
                              </div>
                          </div>
                      </div>
                  )
              }
          </div>
        );
    }
}

export default ArticleBox



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ArticleBox/index.tsx